import React from 'react';
import AppContainer from '../app-container';
import * as stageActions from '../../actions/stages';
import * as participantActions from '../../actions/participant';
import {browserHistory} from 'react-router';
import ReactPixel from 'react-facebook-pixel';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ParticipantForm from '../../components/participant/participant-form';
import LocalizedStrings from '../../localization/strings';
import Loading from '../../components/loading';
import DocumentTitle from 'react-document-title';
import {paymentUrl} from '../../utils/url';

class StageRegistrationPageContainer extends AppContainer {

    constructor(props) {
        super(props);
        this.state = {
           done: false
        };
    }


    componentWillMount() {
        this.props.actions.initializeParticipantFormData({
            stageId: parseInt(this.props.params.itemId, 10)
        });
        this.props.actions.fetchStage(this.props.params.itemId).then(this.handlePageResult.bind(this)).then(this.trackEvent.bind(this));
    }

    trackEvent() {
        const {stage} = this.props;


        if (window.CARE_CONFIG.settings.fb_pixel_code && window.CARE_CONFIG.settings.fb_pixel_code.length) {
            ReactPixel.track('add-to-cart', {stage: stage.item.id})
        }
    }

    onSuccessSubmit(wasNew, result) {
        const {stage} = this.props;

        this.setState({
            done: true
        });
        if (window.CARE_CONFIG.settings.fb_pixel_code && window.CARE_CONFIG.settings.fb_pixel_code.length) {
            ReactPixel.track('initiate-checkout', {stage: stage.item.id})
        }
        if(window.CARE_CONFIG.instantPayment && !result.payment.payed){
            window.location.replace(`${window.CARE_CONFIG.baseUrl}${paymentUrl(result.uuid)}`)
        } else {
            browserHistory.push(`/participant/${result.uuid}`);
        }
    }

    renderForm() {
        const {stage, actions} = this.props;

        return (stage.item.registration_enabled
            ? <ParticipantForm submit={actions.submitParticipant} onSuccessSubmit={this.onSuccessSubmit.bind(this)} disableStageSelect={true} showAlert={false}></ParticipantForm>
            : <h4>{LocalizedStrings.registrationClosed}</h4>);
    }

    render() {
        const {stage} = this.props;

        return (
            <DocumentTitle title={this.getDocumentTitle(LocalizedStrings.registration)}>

                <div className="page-section">
                    <div className="container">
                        <h1 className="title">
                            <span>{stage.item.name}
                            </span>
                        </h1 >
                        <h3 className="title">
                            <span>{LocalizedStrings.registration}
                            </span>
                        </h3>
                        {stage.loading || this.state.done
                            ? <Loading/>
                            : this.renderForm()}

                    </div>
                </div>
            </DocumentTitle>
        )

    }
}
export default connect(function(state) {
    return {stage: state.stage.stage, participant: state.participant.participant};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...stageActions,
            ...participantActions
        }, dispatch)
    };
})(StageRegistrationPageContainer);



// WEBPACK FOOTER //
// ./src/js/containers/pages/stage-registration-page-container.js